import Grid from '@mui/material/Grid';
import { cloneElement, memo } from 'react';

const GridWrapper = (props: { children: any }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
      <Grid container spacing={0} columnSpacing={1}>
        {Array.isArray(props.children)
          ? props.children.map((child: any, mapIndex: number) => {
            return cloneElement(child, {
              key: mapIndex,
            })
          })
          : cloneElement(props.children, {
            item: true
          })}
      </Grid>
    </div>
  )
}
export default memo(GridWrapper);
